module.exports = __webpack_public_path__ + "img/etapa3.d7d66a7b.png";